export const enum SensorMode {
    Motion,
    Angle
}